import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FavoriteIcon } from 'foundations-assets';
import { FavoriteHollowIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { useTracker } from '../../utils/hooks/useTracker';
import { EVENTS } from '../../utils/usageTracker';
import { FAVORITE_ACTION_LOCATIONS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const showErrorAlert = message => {
  ReportActionsFloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    }),
    type: 'danger'
  });
};
export const FavoriteAssetButton = props => {
  const {
    actionLocation,
    assetType,
    disabledMessage,
    enabledMessage,
    isFavorite,
    onAddFavorite,
    onRemoveFavorite,
    appUsageTracker
  } = props;
  const usageTracker = useTracker(appUsageTracker);
  const [isFilled, setIsFilled] = useState(isFavorite);
  const ActionIcon = isFilled || disabledMessage ? FavoriteIcon : FavoriteHollowIcon;
  const iconColor = isFilled ? 'fill-accent-yellow-default' : disabledMessage ? 'icon-tertiary-disabled' : 'icon-tertiary-default';
  const onClick = () => {
    setIsFilled(!isFilled); //provides immediate visual feedback
    const onUpdate = isFilled ? onRemoveFavorite : onAddFavorite;
    onUpdate().then(() => {
      if (usageTracker) {
        usageTracker.track(EVENTS.updateFavoriteAssetsNew, {
          action: isFilled ? 'remove-favorite' : 'add-favorite',
          assetType,
          location: actionLocation
        });
      }
    }, () => {
      setIsFilled(isFilled);
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, actionLocation === FAVORITE_ACTION_LOCATIONS.SINGLE_ASSET_VIEW ? {
    use: 'unstyled',
    marginInlineEnd: '200'
  } : {
    use: 'transparent',
    placement: 'top'
  }, {
    "data-test-id": "favorite-asset-icon-button",
    tooltip: disabledMessage || enabledMessage,
    disabled: !!disabledMessage && !isFilled,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(IconHolder, {
      icon: ActionIcon,
      color: iconColor,
      size: "600"
    })
  }));
};
export default FavoriteAssetButton;